module.exports = __webpack_public_path__ + "img/weixin-1.78540d75.jpg";